'use client';

import * as Sentry from '@sentry/nextjs';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // Log the error to Sentry
  Sentry.captureException(error, {
    tags: {
      component: 'GlobalError',
      error_boundary: true,
    },
  });

  return (
    <html>
      <body>
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
          <div className="max-w-md w-full space-y-6 text-center">
            <div className="space-y-2">
              <h1 className="text-2xl font-bold text-foreground">
                Something went wrong
              </h1>
              <p className="text-muted-foreground">
                We apologize for the inconvenience. Our team has been notified and is working to fix this issue.
              </p>
            </div>

            {process.env.NODE_ENV === 'development' && (
              <div className="bg-muted p-4 rounded-lg text-left">
                <h3 className="font-semibold text-sm mb-2">Error Details (Development Only):</h3>
                <pre className="text-xs text-muted-foreground overflow-auto max-h-32">
                  {error.message}
                  {error.digest && `\nDigest: ${error.digest}`}
                </pre>
              </div>
            )}

            <div className="flex gap-3 justify-center">
              <button
                onClick={() => reset()}
                className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2"
              >
                Try Again
              </button>

              <button
                onClick={() => window.location.href = '/'}
                className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2"
              >
                Go Home
              </button>
            </div>

            <p className="text-xs text-muted-foreground">
              Error ID: {Sentry.lastEventId()}
            </p>
          </div>
        </div>
      </body>
    </html>
  );
}